import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
});

export default api;
